import { Link, Outlet, useRouterState } from '@tanstack/react-router';
import { cn } from '@shigo-ui/ui/cn';

import { dashboardT } from '../../../../lib/messages';
import { SupplyListsTab } from '../model';

const tabs = [
  { tab: SupplyListsTab.All, label: 'lists.tabs.all' },
  { tab: SupplyListsTab.Rewrite, label: 'lists.tabs.rewrite' },
  { tab: SupplyListsTab.Schain, label: 'lists.tabs.schain' },
] as const;

export function ListsLayout() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <nav
        aria-label={dashboardT('lists.tabs.label')}
        className="border-border bg-card page-gutter shrink-0 border-b"
      >
        <div className="flex min-w-max gap-1 overflow-x-auto">
          {tabs.map(({ tab, label }) => {
            const to = `/supply/lists/${tab}` as const;
            const active = pathname === to;
            return (
              <Link
                key={tab}
                to={to}
                search={{}}
                aria-current={active ? 'page' : undefined}
                className={cn(
                  'text-muted-foreground border-b-2 border-transparent px-3 py-3 text-sm font-medium whitespace-nowrap transition-colors',
                  active && 'shigo-supply-tab--active',
                )}
              >
                {dashboardT(label)}
              </Link>
            );
          })}
        </div>
      </nav>
      <Outlet />
    </div>
  );
}
